<template>
  <!-- 博客首页 -->
  <v-app-bar app dark :color="navColor" flat tile class="logo-name" height="66px">
    <!-- logo -->
    <div class="d-flex align-center" style="cursor:pointer" @click="toPage('/blog/home')">
      <v-img alt="Logo" class="shrink mr-2" contain dark width="40"
        :src="logo" transition="scale-transition"/>
      <span class="logo-name">{{ logoName }}</span>
    </div>
    <v-spacer></v-spacer>
    <!-- 导航菜单栏 -->
    <v-btn text @click='toPage("/blog/home")'>
      <span class="mr-4 header-title"><v-avatar :color="navColor" size='22'><img :src="HOMEPNG"></v-avatar>首页</span>
    </v-btn>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text @click='toPage("notes")' v-bind="attrs" v-on="on">
          <span class="mr-4 header-title"><v-avatar :color="navColor" size='24'><img :src="NOTE"></v-avatar>哦，酱紫！</span>
        </v-btn>
      </template>
      <span>学习笔记</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text @click='toPage("secret")' v-bind="attrs" v-on="on">
          <span class="mr-4 header-title"><v-avatar :color="navColor" size='24'><img :src="EMOJ"></v-avatar>嗯嗯！</span>
        </v-btn>
      </template>
      <span>个人随笔</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text @click='toPage("solution")' v-bind="attrs" v-on="on">
          <span class="mr-4 header-title"><v-avatar :color="navColor" size='24'><img :src="IDEA"></v-avatar>呀，有坑！</span>
        </v-btn>
      </template>
      <span>踩坑小记</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text @click='toPage("collection")' v-bind="attrs" v-on="on">
          <span class="mr-4 header-title"><v-avatar :color="navColor" size='24'><img :src="COLLECTION"></v-avatar>哎呦，不错！</span>
        </v-btn>
      </template>
      <span>收藏夹</span>
    </v-tooltip>

    <!-- 切换主题 -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click="changeTheme" v-bind="attrs" v-on="on" small>
          <v-avatar :color="navColor" size='27'><img :src="SUBJECT"></v-avatar>
        </v-btn>
      </template>
      <span>切换主题</span>
    </v-tooltip>

    <!-- 切换菜单颜色 -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click="$emit('changeColor')" :color="color" v-bind="attrs" v-on="on" small>
          <v-avatar :color="navColor" size='24'><img :src="PALETTE"></v-avatar>
        </v-btn>
      </template>
      <span>切换菜单颜色</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
import CONFIG from '@/config/config.js';
import IDEA from "@/assets/imgs/nav/idea.png"
import EMOJ from "@/assets/imgs/nav/emoj.png"
import HOMEPNG from "@/assets/imgs/nav/home.png"
import NOTE from "@/assets/imgs/nav/notebook.png"
import SUBJECT from "@/assets/imgs/nav/subject.png"
import PALETTE from "@/assets/imgs/nav/palette.png"
import COLLECTION from "@/assets/imgs/nav/collection.png"

export default {
  name: 'App',
  props:{
    navColor:{
      type:String,
      default:"#000000"
    },
    color:{
      type:String,
      default:"#4CAF50"
    }
  },
  data () {
    return {
      NOTE,
      IDEA,
      EMOJ,
      SUBJECT,
      HOMEPNG,
      PALETTE,
      COLLECTION,
      nSearch:true,
      searchWord:"",
      theme:"light",
    }
  },
  computed: { 
    logoName: function () {
      return CONFIG.TITLE
    },
    logo:function () {
      return CONFIG.LOGO
    }
  },
  methods:{
    toPage(url){
      if (url.startsWith("http://")){
        window.open(url, "_blank");
      }else if(url.startsWith("/")){
        this.$router.push({path: url})
      }else{
        this.$router.push({path:"/blog/category", query:{type: url}})
      }
    },
    changeTheme(){
      if(this.theme === "dark"){
        this.theme = "light";
        this.$vuetify.theme.dark = false;
        this.$vuetify.theme.light = true;
      }else{
        this.theme = "dark";
        this.$vuetify.theme.dark = true;
        this.$vuetify.theme.light = false;
      }
    },
  },
  mounted() {
    this.$vuetify.theme.dark = false;
    this.$vuetify.theme.light = true;
  }
}
</script>

<style lang="stylus" scoped>
.logo-name
  font-size 22px

.search-input
  width 160px
  margin-bottom -10px
  margin-left 10%

.blogger-content
  position absolute
  top  0
  bottom 0
  border 0
  right 0
  left 0
  width 100%
  height:100%
.blogger-footer
  position absolute
  bottom 0
.header-title
  font-size 18px
</style>
